import React from "react";
import Stemp from "./Stemp";
import "./css/Work.css"
export default function Skills()
{
    let Skills=["Cpp","Python","Java","C","Sql","Html","Css","Js","React","Git","Mongodb","Django","Flask","FastAPI","GoogleAppsScript","Redis","SpringBoot","Postgres"];
    Skills=Skills.map((name)=>{return <Stemp image={`./images/${name}.png`} alt={name} />})
    return (
        <div className="work">
            <h1 className="heading one">Skills</h1>
            <div className="flex-container skills">
                {Skills}
            </div>
        </div>
    ) 
}
